/** @module Common */
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';
import { coordDistance, formatSecToHumanTime } from '@pysae/transit-core/helpers';

dayjs.extend(utc);

type Coord = {
  latitude: number;
  longitude: number;
};

const Common = {
  /**
   * Convert a date String formatted like YYYYMMDD (as in GTFS specification) to a Date object.
   */
  dateGtfsFormatToObj(str: string, utc: boolean = false): Date {
    return utc ? dayjs(str, 'YYYYMMDD').utc(true).toDate() : dayjs(str, 'YYYYMMDD').toDate();
  },

  /**
   * returns string with no accents, no spaces and all lowercase
   */
  normalize(input: string): string {
    return input
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  },

  /**
   * Check if a variable is an object
   */
  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  },

  /**
   * Check if an object is not empty
   */
  isEmptyObject(obj: object): boolean {
    return Object.keys(obj).length === 0;
  },

  /**
   * Format a time in seconds to a time formated in hour-minutes ex : '1h20'
   */
  formatSec(seconds: number, acceptNegativeValue: boolean = false): string {
    return formatSecToHumanTime(seconds, acceptNegativeValue);
  },

  /**
   * Convert a timestamp in HHhMM time format.
   */
  timestampFormatHHMM(timestamp: number): string {
    const timestampDate = new Date(timestamp * 1000);
    return dayjs(timestampDate).format('HH[h]mm');
  },

  /**
   * Calculate distance between two coordinates in meters
   */
  coordDistance(a: Coord, b: Coord): number {
    return coordDistance(a, b);
  },

  /**
   * get an item from ls & parse it in JSON
   */
  safeLSParse(key: string): any {
    try {
      const lsItem = localStorage.getItem(key);
      if (!lsItem) return null;
      return JSON.parse(lsItem);
    } catch {
      return null;
    }
  },
};

export default Common;
